import React from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { compose } from 'underscore';
import { mergeStyles } from '@bingads-webui-campaign-react/common-styles';
import { HotelCampaignBase, scenarios } from './shared';
import { sharedStyles } from './style';

const getStyles = (_, theme) => ({
  ...mergeStyles(
    { theme },
    sharedStyles,
    {
      hotelCampaignBase: {
        paddingLeft: '32px',
      },
    }
  ),
});

export const HotelCampaignSettings = compose(
  withI18nConsumer,
  WrappedComponent => withDefaultStyles(WrappedComponent, getStyles)
)(props => (<HotelCampaignBase {...props} scenario={scenarios.settings} />));

